<template>
  <div>
    <div id="box" class="pa-5 mt-5">
      <!-- Header: title + breadcrumb + buttons -->
      <v-row class="pb-5 align-center" style="padding: 0px 2.5% 20px 2.5%">
          <v-icon class="ma-0 pa-0" size="28" style="color:#ED6D00">mdi-menu-right</v-icon>
          <h4 class="primary-color" style="padding-top:2px">{{ sectionTitle || $t('__s3Files') }}</h4>
          <v-spacer></v-spacer>
          <!-- Breadcrumbs -->
          <div v-if="breadcrumbs.length > 0" class="d-flex align-center" style="flex-wrap:wrap;">
            <v-btn x-small text color="#ED6D00" class="px-1" style="min-width:0" @click="navigateTo(-1)">
              <v-icon x-small>mdi-home-outline</v-icon>
            </v-btn>
            <span v-for="(crumb, idx) in breadcrumbs" :key="idx" class="d-flex align-center">
              <v-icon x-small color="#bbb">mdi-chevron-right</v-icon>
              <v-btn x-small text color="#ED6D00" class="px-1" @click="navigateTo(idx)">{{ crumb }}</v-btn>
            </span>
          </div>
        <div class="d-flex" style="gap:6px;" v-if="!readOnly">
          <v-btn class="white--text" color="#ED6D00" depressed style="border-radius:8px;" @click="triggerUpload" :loading="isUploading">
            {{ $t('__addAttachment') }}
          </v-btn>
          <input ref="s3FileInput" type="file" style="display:none" @change="handleUpload" />
        </div>
      </v-row>

      <!-- File Table -->
      <div id="listTable" class="ma-0">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-4">
                <th class="text-left font-weight-bold pl-3" style="width:50%">{{ $t('__fileName') }}</th>
                <th class="text-center font-weight-bold" style="width:18%">{{ $t('__uploadDate') }}</th>
                <th class="text-center font-weight-bold" style="width:32%"></th>
              </tr>
            </thead>
            <tbody>
              <!-- Loading -->
              <tr v-if="isLoading">
                <td colspan="3" class="text-center py-6">
                  <v-progress-circular indeterminate color="#ED6D00" size="28"></v-progress-circular>
                </td>
              </tr>
              <template v-else>
                <!-- Go Back row -->
                <tr v-if="canGoBack" class="hover-row" style="cursor:pointer;" @click="goBack">
                  <td colspan="3" class="text-left py-3 pl-3" style="color:#888;font-size:13px;font-style:italic;">
                    <v-icon small color="#888" class="mr-1">mdi-arrow-up-left</v-icon>{{ $t('__s3GoBack') }}
                  </td>
                </tr>
                <!-- Empty -->
                <tr v-if="subfolders.length === 0 && fileList.length === 0 && !canGoBack">
                  <td colspan="3" class="text-center grey--text py-10 font-italic">{{ $t('__s3NoFiles') }}</td>
                </tr>
                <!-- Subfolders -->
                <tr v-for="(sf, idx) in subfolders" :key="'sf'+idx"
                    class="hover-row" :class="idx % 2 === 0 ? '' : 'row-even'"
                    style="cursor:pointer;" @click="navigateInto(sf)">
                  <td class="text-left py-2 pl-3" colspan="2">
                    <v-icon small class="mr-2" color="#ED6D00">mdi-folder</v-icon>
                    <span style="font-weight:500;color:#333;">{{ sf.name }}</span>
                  </td>
                  <td class="text-center">
                    <v-icon small color="#ccc">mdi-chevron-right</v-icon>
                  </td>
                </tr>
                <!-- Files -->
                <tr v-for="(file, idx) in fileList" :key="'f'+idx"
                    :class="(subfolders.length + idx) % 2 === 1 ? 'row-even' : ''">
                  <td class="text-left py-2 pl-3" style="min-width:200px; word-break:break-all;">
                    <v-icon small class="mr-1" color="#90A4AE">mdi-file-outline</v-icon>{{ file.displayName }}
                  </td>
                  <td class="text-center" style="min-width:70px">{{ file.lastModified }}</td>
                  <td class="text-center" style="min-width:200px">
                    <v-avatar color="#ED6D00" size="30" tile @click="previewFile(file)" :loading="file.loadingPreview"
                    class="action-btn-edit mr-1" style="cursor: pointer;">
                      <v-icon color="#FFFFFF" size="20">mdi-eye-outline</v-icon>
                    </v-avatar>
                    <v-avatar v-if="!readOnly" color="#4C4948" size="30" tile @click="confirmDelete(file)"
                    class="action-btn-delete" style="cursor: pointer;">
                      <v-icon color="#FFFFFF" size="20">mdi-delete</v-icon>
                    </v-avatar>
                    <!-- <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar v-bind="attrs" v-on="on" color="#ED6D00" size="30" tile @click="previewFile(file)" :loading="file.loadingPreview"
                          class="action-btn-edit mr-1" style="cursor: pointer;">
                          <v-icon color="#FFFFFF" size="20">mdi-eye-outline</v-icon>
                        </v-avatar>
                      </template>
                      <span>{{ $t('__s3Preview') }}</span>
                    </v-tooltip>
                    <v-tooltip bottom v-if="!readOnly">
                      <template v-slot:activator="{ on, attrs }">
                        <v-avatar v-bind="attrs" v-on="on" color="#4C4948" size="30" tile @click="confirmDelete(file)"
                          class="action-btn-delete" style="cursor: pointer;">
                          <v-icon color="#FFFFFF" size="20">mdi-delete</v-icon>
                        </v-avatar>
                      </template>
                      <span>{{ $t('__s3Delete') }}</span>
                    </v-tooltip> -->
                  </td>
                </tr>
              </template>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </div>

    <!-- Preview Dialog -->
    <v-dialog v-model="showPreviewDialog" min-width="500px" max-width="700px" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{$t('__s3Preview')}}</span>
          <v-btn icon @click="showPreviewDialog = false"><v-icon size="30" color="#9E9E9E">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pa-4" v-if="previewFile_">
          <div v-if="isImageFile(previewFile_.displayName)" class="text-center mb-4">
            <img :src="previewFile_.preSignedUrl" style="max-width:100%;max-height:380px;border-radius:8px;border:1px solid #eee;" />
          </div>
          <div v-else class="text-center mb-4 py-6">
            <v-icon size="60" color="#ED6D00">mdi-file-document-outline</v-icon>
            <div class="mt-2 grey--text">{{ previewFile_.displayName }}</div>
          </div>
          <div class="mb-1" style="font-size:13px;color:#666;font-weight:500;">{{ $t('__s3PreviewUrl') }}</div>
          <div class="d-flex align-center" style="gap:8px;">
            <v-text-field class="mt-1" :value="previewFile_.preSignedUrl" readonly outlined dense hide-details style="font-size:12px;"></v-text-field>
            <v-btn class="ma-0 colorBtn primary-color-background" outlined color="#FFF" style="width:20%; height:40px !important" @click="copyUrl(previewFile_.preSignedUrl)">
              <v-icon class="search-bar-max" left small>mdi-content-copy</v-icon> 
              {{(displayMode === 0) ? $t('__copy'): $t('__copyWeb')}}
            </v-btn>
            <v-btn class="ma-0 colorBtn open-background" outlined color="#FFF" style="width:20%; height:40px !important"  :href="previewFile_.preSignedUrl" target="_blank">
              <v-icon class="search-bar-max" left small>mdi-open-in-new</v-icon>
              {{(displayMode === 0) ? $t('__open'): $t('__openWeb')}}
            </v-btn>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>



    <!-- Delete Confirm Dialog -->
    <v-dialog v-model="showDeleteDialog" max-width="500" persistent>
      <v-card class="dialog-padding">
        <v-card-title class="d-flex justify-space-between align-center pa-4">
          <span class="dialog-title">{{$t('__s3Delete')}}</span>
          <v-btn icon @click="showDeleteDialog = false"><v-icon size="30" color="#9E9E9E">mdi-close</v-icon></v-btn>
        </v-card-title>

        <v-card-text class="text-left mt-1" style="font-weight:600; height:80px; font-size:15px">
          {{ $t('__s3DeleteConfirm') }}
          <div v-if="deleteTarget" class="mt-2 font-weight-bold primary-color" style="word-break:break-all;">{{ deleteTarget.displayName }}</div>
        </v-card-text>
        <v-card-actions class="px-3" style="justify-content:center">
          <v-btn class="colorBtn" outlined color="#FFF" @click="showDeleteDialog = false">
            {{ $t('__cancel') }}
          </v-btn>
          <v-btn class="colorBtn primary-color-background" outlined color="#FFF" @click="executeDelete" :loading="isDeleting">
            {{ $t('__s3Delete') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top right timeout="3000">
      {{ snackbar.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">✕</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: 'S3FileManager',
  props: {
    folder: { type: String, required: true },
    // Fixed start subfolder - navigation cannot go above this
    subPath: { type: String, default: '' },
    sectionTitle: { type: String, default: '' },
    readOnly: { type: Boolean, default: false },
    // Optional: if provided, S3FileManager will skip List API and use these instead
    fixedFiles: { type: Array, default: null }
  },
  data: () => ({
    isLoading: false,
    isUploading: false,
    isDeleting: false,
    displayMode:'',
    fileList: [],
    subfolders: [],
    // currentRelPath: extra path navigated BELOW the locked subPath
    currentRelPath: '',
    // currentPrefix: from last List response (used for CreateSubfolder parentPrefix)
    currentPrefix: '',
    // Preview
    showPreviewDialog: false,
    previewFile_: null,
    // Rename
    showDeleteDialog: false,
    deleteTarget: null,
    // Snackbar
    snackbar: { show: false, message: '', color: 'success' }
  }),
  computed: {
    // The full subPath being viewed (subPath prop + currentRelPath)
    effectiveSubPath() {
      const base = (this.subPath || '').replace(/\/$/, '')
      const rel  = (this.currentRelPath || '').replace(/\/$/, '')
      if (!base && !rel) return ''
      if (!base) return rel
      if (!rel) return base
      return `${base}/${rel}`
    },
    canGoBack() { return !!this.currentRelPath },
    breadcrumbs() {
      if (!this.currentRelPath) return []
      return this.currentRelPath.split('/').filter(Boolean)
    }
  },
  watch: {
    subPath: {
      handler: function(newVal, oldVal) {
        if (newVal === oldVal) return
        this.currentRelPath = ''
        this.loadFiles()
      }
    },
    fixedFiles: {
      immediate: true,
      deep: true,
      handler: function(newVal, oldVal) {
        if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return
        this.loadFiles()
      }
    }
  },
  mounted() {
    this.calculateWindows()
  },
  methods: {
    calculateWindows(){
      if(window.innerWidth >= 960){
        this.displayMode = 0
      } else {
        this.displayMode = 1
      }
    },
    formatDate(isoStr) {
      if (!isoStr) return ''
      const d = new Date(isoStr)
      if (isNaN(d)) return isoStr
      return `${d.getFullYear()}/${String(d.getMonth()+1).padStart(2,'0')}/${String(d.getDate()).padStart(2,'0')}`
    },
    isImageFile(name) { return /\.(jpg|jpeg|png|gif|bmp|webp|svg)$/i.test(name || '') },
    showMsg(msg, color = 'success') {
      this.snackbar.message = msg
      this.snackbar.color = color
      this.snackbar.show = true
    },
    mapFileItem(item) {
      // Handle if item itself is still a JSON string
      let target = item
      if (typeof item === 'string' && (item.startsWith('{') || item.startsWith('['))) {
        try { target = this.deepParse(item); if (Array.isArray(target) && target.length > 0) target = target[0]; } catch(e) {}
      }
      
      let rawName = target.fileName || target.FileName || (target.key || target.filePath || '').split('/').pop() || ''
      return {
        key: target.key || target.Key || target.filePath || '',
        displayName: rawName.replace(/_[a-zA-Z0-9]{32}(?=\.[^.]+$)/, ''),
        lastModified: this.formatDate(target.lastModified || target.LastModified || ''), // may be empty for fixed files
        loadingPreview: false
      }
    },
    // Extract folder display name from full S3 path, relative to current effectiveSubPath
    extractFolderName(fullPath) {
      const prefix = this.folder + '/' + (this.effectiveSubPath ? this.effectiveSubPath + '/' : '')
      let rel = fullPath.startsWith(prefix) ? fullPath.slice(prefix.length) : fullPath
      return rel.replace(/\/$/, '').split('/').filter(Boolean).pop() || ''
    },
    deepParse(val) {
      if (val === null || val === undefined) return []
      if (typeof val === 'string') {
        var trimmed = val.trim()
        // Handle escaped double quotes common in double-serialized data
        if (trimmed.startsWith('"') && trimmed.endsWith('"')) {
          try {
             const unescaped = JSON.parse(trimmed)
             return this.deepParse(unescaped)
          } catch(e) {}
        }
        if (!trimmed.startsWith('{') && !trimmed.startsWith('[')) return val
        try {
          const parsed = JSON.parse(val)
          return this.deepParse(parsed)
        } catch (e) {
          return val
        }
      }
      if (Array.isArray(val)) {
        var result = []
        val.forEach(item => {
          const parsed = this.deepParse(item)
          if (Array.isArray(parsed)) {
            result = result.concat(parsed)
          } else {
            result.push(parsed)
          }
        })
        return result
      }
      return val
    },
    loadFiles() {
      // Prioritize fixed files if they are provided and have content.
      // This is essential for closed jobs (where S3 path might not match ID)
      // but also speeds up active jobs by using pre-fetched metadata.
      const filesToUse = this.deepParse(this.fixedFiles)
      if (filesToUse && filesToUse.length > 0) {
        this.isLoading = false
        this.subfolders = []
        this.fileList = filesToUse.map(item => this.mapFileItem(item))
        return
      }

      // If we are definitely in read-only mode, we strictly respect the fixedFiles list even if empty
      // to avoid hitting the S3 List API which might return irrelevant results for that ID.
      if (this.readOnly && this.fixedFiles !== null) {
        this.isLoading = false
        this.subfolders = []
        this.fileList = []
        return
      }

      // Standard behavior: fetch from S3 for mutable/active folders
      this.isLoading = true
      const ep = this.effectiveSubPath
      const params = ep ? { subPath: ep } : {}
      this.$http.get(`/S3/${this.folder}/List`, { params }).then(response => {
        const data = response.data?.Data || response.data?.data || response.data || {}
        if (Array.isArray(data)) {
          // Legacy flat array format
          this.subfolders = []
          this.fileList = data.map(item => this.mapFileItem(item))
          this.currentPrefix = ''
        } else {
          this.currentPrefix = data.currentPrefix || data.CurrentPrefix || ''
          const rawSubs = data.subfolders || data.Subfolders || []
          this.subfolders = rawSubs.map(sf => ({
            fullPath: sf,
            name: this.extractFolderName(sf)
          })).filter(sf => sf.name)
          const rawFiles = data.files || data.Files || []
          this.fileList = rawFiles.map(item => this.mapFileItem(item))
        }
      }).catch(() => this.showMsg('Failed to load files', 'error'))
        .finally(() => { 
          this.isLoading = false 
          // Only emit updates if data actually changed and it's different from what parent has
          const newFilesEmit = this.fileList.map(f => ({
            fileName: f.displayName,
            filePath: f.key
          }))
          const currentFixed = this.deepParse(this.fixedFiles)
          
          if (JSON.stringify(newFilesEmit) !== JSON.stringify(currentFixed)) {
            this.$emit('files-updated', newFilesEmit)
          }
        })
    },
    navigateInto(sf) {
      this.currentRelPath = this.currentRelPath ? `${this.currentRelPath}/${sf.name}` : sf.name
      this.loadFiles()
    },
    goBack() {
      const parts = this.currentRelPath.split('/').filter(Boolean)
      parts.pop()
      this.currentRelPath = parts.join('/')
      this.loadFiles()
    },
    navigateTo(idx) {
      if (idx < 0) { this.currentRelPath = '' }
      else { this.currentRelPath = this.breadcrumbs.slice(0, idx + 1).join('/') }
      this.loadFiles()
    },
    triggerUpload() { this.$refs.s3FileInput.click() },
    handleUpload(event) {
      const file = event.target.files[0]
      if (!file) return
      event.target.value = ''
      this.isUploading = true
      const formData = new FormData()
      formData.append('file', file)
      const ep = this.effectiveSubPath
      const qs = ep ? `?subFolder=${encodeURIComponent(ep)}` : ''
      this.$http.post(`/S3/${this.folder}/Upload${qs}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(() => {
        this.showMsg(this.$t('__s3UploadSuccess'), 'success')
        this.loadFiles()
      }).catch(() => this.showMsg('Upload failed', 'error'))
        .finally(() => { this.isUploading = false })
    },
    previewFile(file) {
      file.loadingPreview = true
      const ep = this.effectiveSubPath
      const realFileName = file.key ? file.key.split('/').pop() : file.displayName
      const params = ep ? { fileName: realFileName, subFolder: ep } : { fileName: realFileName }
      this.$http.get(`/S3/${this.folder}/Get`, { params }).then(response => {
        const data = response.data?.Data || response.data?.data || response.data || {}
        this.previewFile_ = {
          ...file,
          publicUrl: data.publicUrl || data.PublicUrl || '',
          preSignedUrl: data.preSignedUrl || data.PreSignedUrl || data.url || ''
        }
        this.showPreviewDialog = true
      }).catch(() => this.showMsg('Failed to get file URL', 'error'))
        .finally(() => { file.loadingPreview = false })
    },
    copyUrl(url) {
      if (!url) return
      navigator.clipboard.writeText(url).catch(() => {
        const el = document.createElement('textarea')
        el.value = url
        document.body.appendChild(el); el.select(); document.execCommand('copy'); document.body.removeChild(el)
      }).finally(() => this.showMsg(this.$t('__s3UrlCopied'), 'info'))
    },

    confirmDelete(file) { this.deleteTarget = file; this.showDeleteDialog = true },
    executeDelete() {
      if (!this.deleteTarget) return
      this.isDeleting = true
      this.$http.post(`/S3/${this.folder}/Delete`, null, { params: { key: this.deleteTarget.key } })
        .then(() => { this.showMsg(this.$t('__s3DeleteSuccess'), 'success'); this.showDeleteDialog = false; this.loadFiles() })
        .catch(() => this.showMsg('Delete failed', 'error'))
        .finally(() => { this.isDeleting = false; this.deleteTarget = null })
    },
  }
}
</script>

<style scoped>
#box { background-color: white; border-radius: 8px; }
.custom-table thead th { background-color: #F5F5F5 !important; color: #333 !important; font-size: 14px !important; font-weight: bold !important; }
.custom-table tbody td { font-size: 14px !important; color: #555 !important; height: 46px !important; }
.row-even { background-color: #FFF8F1 !important; }
.hover-row:hover { background-color: #FFF3E6 !important; }
.border { border: 1px solid #EEEEEE; }
.dialog-btn { width: 140px; margin: 0 6px; border-radius: 8px; }
</style>
